import React from 'react';
import {StyleSheet, View} from 'react-native';

import {FEED_ITEM_OUTER_MARGIN_HORIZONTAL} from '../../../constants/feedLayout';
import {getSkeletonColors, STAGGER} from '../constants';
import {Bone} from '../primitives/Bone';
import {BoneText} from '../primitives/BoneText';

/**
 * Skeleton for FeedTile in the home feed list.
 * Mirrors: BaseTile shell + FeedTile's full-width banner + 2-line headline
 *   (frontend/app/components/articleTile/FeedTile.tsx,
 *    frontend/app/components/articleTile/BaseTile.tsx:123-150).
 */
type Props = {
  index?: number;
};

export const FeedTileSkeleton: React.FC<Props> = React.memo(({index = 0}) => {
  const base = (index % 3) * STAGGER.interval;
  return (
    <View style={styles.container} accessibilityElementsHidden>
      <Bone width="100%" height={200} borderRadius={0} animationDelay={base} />
      <View style={styles.textBlock}>
        <BoneText variant="h1" width="92%" animationDelay={base + STAGGER.delay(1)} />
        <BoneText variant="h1" width="68%" animationDelay={base + STAGGER.delay(2)} />
        <BoneText variant="caption" width="40%" animationDelay={base + STAGGER.delay(3)} />
      </View>
    </View>
  );
});

FeedTileSkeleton.displayName = 'FeedTileSkeleton';

const styles = StyleSheet.create({
  container: {
    marginHorizontal: FEED_ITEM_OUTER_MARGIN_HORIZONTAL,
    marginBottom: 12,
    borderRadius: 4,
    borderWidth: 0.5,
    borderColor: getSkeletonColors().border,
    backgroundColor: getSkeletonColors().cardBackground,
    overflow: 'hidden',
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 5},
    shadowOpacity: 0.29,
    shadowRadius: 4.65,
    elevation: 7,
  },
  textBlock: {
    paddingHorizontal: 12,
    paddingVertical: 8,
    gap: 6,
  },
});
